import "./polyfills";
import "./config/axios";

require("./react/Root");
